/* Shove Day Essentials product carousel — manual prev/next + optional autoplay */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.poSdeInit === '1') return;
    root.dataset.poSdeInit = '1';

    var rail = root.querySelector('.po-sde__rail');
    var btns = root.querySelectorAll('.po-sde__btn');
    if (!rail) return;

    function step(dir) {
      var card = rail.querySelector('.po-sde__card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(rail).gap || '0');
      var delta = (card.offsetWidth + gap) * dir;
      rail.scrollBy({ left: delta, behavior: 'smooth' });
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = parseInt(b.dataset.dir, 10) || 1;
        step(dir);
        stopAuto();
      });
    });

    rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
      if (e.key === 'ArrowLeft')  { step(-1); e.preventDefault(); }
    });

    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.autoplayInterval, 10);
    if (isNaN(interval) || interval < 2) interval = 6;
    var timer = null;
    function startAuto() {
      if (!autoplay || timer) return;
      timer = setInterval(function () {
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
        if (atEnd) {
          rail.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          step(1);
        }
      }, interval * 1000);
    }
    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    startAuto();
  }

  function boot() {
    document.querySelectorAll('.po-sde').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
